// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1761) return "static/chunks/d0deef33-fc5ed3dc4589a029.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6115":"7bbdc1733771d22d","6971":"28c122e2a54f5447","8129":"e314c000068df04b","9518":"4815c1741f85a020"}[chunkId] + ".js";
};